import moment from "moment";

export class CalendarRepeatInterval {
  constructor() {
    this.startDate = undefined;
    this.endDate = undefined;
    this.repeatEveryCount = 0;
    this.type = undefined;
  }

  static fromJSON(json) {
    if (!json || !json.type) return undefined;

    switch (json.type) {
      case CALENDAR_REPEAT_INTERVAL_TYPE.Monthly: {
        return MonthlyRepeatInterval.fromJSON(json);
      }
      case CALENDAR_REPEAT_INTERVAL_TYPE.Weekly: {
        return WeeklyRepeatInterval.fromJSON(json);
      }
      case CALENDAR_REPEAT_INTERVAL_TYPE.Yearly: {
        return YearlyRepeatInterval.fromJSON(json);
      }
      default: {
        return undefined;
      }
    }
  }

}

export class MonthlyRepeatInterval extends CalendarRepeatInterval {
  constructor() {
    super();

    this.repeatDaysOfTheMonth = [];
    this.repeatMonthlyOnEvery = undefined;
    this.repeatOnDays = undefined;
    this.type = CALENDAR_REPEAT_INTERVAL_TYPE.Monthly;
  }

  static fromJSON(json) {
    return Object.assign(new MonthlyRepeatInterval(), json);
  }
}

export class WeeklyRepeatInterval extends CalendarRepeatInterval {
  constructor() {
    super();

    this.repeatOnDays = undefined;
    this.type = CALENDAR_REPEAT_INTERVAL_TYPE.Weekly;
  }

  static fromJSON(json) {
    return Object.assign(new WeeklyRepeatInterval(), json);
  }
}

export class YearlyRepeatInterval extends CalendarRepeatInterval {
  constructor() {
    super();

    this.repeatOnDates = [];
    this.type = CALENDAR_REPEAT_INTERVAL_TYPE.Yearly;
  }

  static fromJSON(json) {
    let repeatInterval = Object.assign(new YearlyRepeatInterval(), json);
    repeatInterval.repeatOnDates = repeatInterval.repeatOnDates
      .map(ds => moment(ds).format("YYYY-MM-DD"));

    return repeatInterval;
  }
}

export class CALENDAR_REPEAT_INTERVAL_TYPE {
  static Weekly = 'WeeklyRepeatInterval';
  static Monthly = 'MonthlyRepeatInterval';
  static Yearly = 'YearlyRepeatInterval';
}
